import { render } from "./AttendanceWarnConfig.vue?vue&type=template&id=44061169"
import script from "./AttendanceWarnConfig.vue?vue&type=script&lang=js"
export * from "./AttendanceWarnConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/laborers/attendance/config/AttendanceWarnConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44061169"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44061169', __exports__)) {
    api.reload('44061169', __exports__)
  }
  
  module.hot.accept("./AttendanceWarnConfig.vue?vue&type=template&id=44061169", () => {
    api.rerender('44061169', render)
  })

}


export default __exports__